<script setup lang="ts">
import {computed, ref} from "vue";
import {Button} from "@/core/components/ui/button";
import ShellUpdateDialog from "@/shell-update/components/ShellUpdateDialog.vue";
import useShellUpdate from "@/shell-update/composables/useShellUpdate";

/**
 * The update link shown right after the version number, when an update is offered.
 */
const props = defineProps<{
    update: ReturnType<typeof useShellUpdate>;
}>();

const dialogOpen = ref(false);

const label = computed(() => {
    if (props.update.isDownloaded.value) {
        return "installer la mise à jour";
    }

    return props.update.isScheduled.value ? "mise à jour programmée" : "mettre à jour";
});

/**
 * Restart on the downloaded version, or open the dialog.
 */
const onClick = () => {
    if (props.update.isDownloaded.value) {
        props.update.install();
    } else {
        dialogOpen.value = true;
    }
};
</script>

<template>
  <Button
    variant="link"
    class="ml-2 h-auto p-0 text-sm font-normal text-primary underline underline-offset-2 hover:opacity-75"
    @click.stop="onClick"
  >
    {{ label }}
  </Button>

  <ShellUpdateDialog
    v-model:open="dialogOpen"
    :target-version="update.offer.value?.target_version ?? null"
    :scheduled="update.isScheduled.value"
    :schedule="update.schedule"
  />
</template>
